import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import BlobDownloader from 'components/UploaderAndDownloader/BlobDownloader';
import style from './DownloadFileBtn.module.scss';

const DownloadFileBtn: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<div className={style.container}>
			<BlobDownloader
				filePath={
					restaurantForFullInfo?.generatedWatchCommandsLink
						? restaurantForFullInfo.generatedWatchCommandsLink
						: null
				}
				fileExtension="zip"
				fileName="watches"
				label="downloadFile"
			/>
		</div>
	);
};

export default DownloadFileBtn;
